import { useEffect } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { createOnboaringBullets } from "./OnboardingElements";

const STEP_IDS = {
    0: "intro",
    1: "video",
    2: "exam",
    3: "support",
    4: "resources",
};

export default function Onboarding({
    profile,
    display = false,
    onOpened = () => {},
    onRequestFinale = () => {},
    onClosedClicked = ({ stepId, stepIdx }) => {},
    onDoneClicked = () => {},
    onFinsiehd = () => {},
}) {
    const imageUrl =
        profile?.gender === "M"
            ? "/images/male-character.svg"
            : "/images/female-character.svg";

    useEffect(() => {
        const driverObj = driver({
            showProgress: false,
            animate: true,
            opacity: 0.5,
            padding: 8,
            allowClose: false,
            nextBtnText: "بعدی",
            prevBtnText: "قبلی",
            doneBtnText: "اتمام",
            popoverClass: "intro",
            // Custom class for styling footer
            stageFooterClass: "intro-footer",
            disableActiveInteraction: true,
            onPopoverRender: (_, { config, state }) =>
                createOnboaringBullets(config, state),
            onCloseClick: (_, __, { config, state, driver }) => {
                const lastIdx = (config?.steps?.length ?? 1) - 1;
                onClosedClicked({
                    stepId: STEP_IDS[state.activeIndex],
                    stepIdx: state.activeIndex,
                });
                onRequestFinale();
                setTimeout(() => {
                    driver.moveTo(lastIdx);
                }, 300);
            },
            onNextClick: (_, __, { state, config, driver }) => {
                const total = config?.steps?.length ?? 1;
                const lastOneIndex = total - 1;
                const theOneBeforeEndIndex = lastOneIndex - 1;
                const currentIndex = driver.getActiveIndex();

                if (currentIndex == theOneBeforeEndIndex) {
                    onDoneClicked();
                    onRequestFinale();
                    setTimeout(() => {
                        driver.moveNext();
                    }, 300);
                } else {
                    driver.moveNext();
                }
            },
            steps: [
                {
                    element: "window",
                    onHighlighted: (_, __, {}) => {
                        onOpened();
                    },
                    popover: {
                        popoverClass: "intro intro-step-0",
                        title: `
                            <div class="intro-header">
                                <p>به دوره تغییر عادت خوش ‌آمدید</p>
                                <button type="button" class="driver-popover-close-btn" aria-label="Close">×</button>
                            </div>
                        `,
                        description: `
                            <div class='intro-step-0-body'>
                                <img src=${imageUrl} />
                                <p>برای آشنایی سریع با سامانه، کافیست ۴ گام ساده را دنبال کنید.</p>
                            </div>
                            `,
                        side: "over",
                        align: "center",
                        showProgress: false,
                        showButtons: ["next"],
                        nextBtnText: "شروع آشنایی با سامانه",
                    },
                },
                {
                    element: "#native-video-player",
                    popover: {
                        popoverClass: "intro intro-step-1",
                        title: `
                            <div class="intro-header">
                                <p>اولویت اول: تماشای ویدیو</p>
                                <button type="button" class="driver-popover-close-btn" aria-label="Close"">×</button>
                            </div>
                        `,
                        description: `
                            <div class="intro-body">
                            <p>قبل از هر کاری، ویدیوی ۱۵ دقیقه‌ای جلسه را تا قبل از ساعت ۱۲ امشب تماشا کنید.</p>
                            </div>
                        `,
                        side: "top",
                        align: "center",
                        showProgress: true,
                        showButtons: ["next"],
                        nextBtnText: "بعدی",
                    },
                },
                {
                    element: "#exam-button",
                    popover: {
                        popoverClass: "intro intro-step-2",
                        title: `
                            <div class="intro-header">
                                <p>ارزیابی یادگیری با ۵ سوال ساده</p>
                                <button type="button" class="driver-popover-close-btn" aria-label="Close"">×</button>
                            </div>
                        `,
                        description: `
                            <div class="intro-body">
                            <p>بعد از تماشای ویدیو، بلافاصله در آزمون شرکت کنید.</p>
                            <p>آزمون شامل ۵ سوال ساده است.</p>
                            </div>
                        `,
                        showButtons: ["next", "previous"],
                        showProgress: true,
                        nextBtnText: "بعدی",
                        prevBtnText: "قبلی",
                    },
                },
                {
                    element: "#goftino_w",

                    popover: {
                        popoverClass: "intro intro-step-3",
                        title: `
                            <div class="intro-header">
                                <p>پاسخ به سوالات از طریق پشتیبانی</p>
                                <button type="button" class="driver-popover-close-btn" aria-label="Close"">×</button>
                            </div>
                        `,
                        description: `
                            <div class="intro-body">
                            <p>می‌توانید از طریق آیکن پشتیبانی، سوال خود را بپرسید.</p>
                            <p>ما در اولین فرصت به آن پاسخ می‌دهیم.</p>
                            </div>
                        `,
                        showButtons: ["next", "previous"],
                        showProgress: true,
                        nextBtnText: "بعدی",
                        prevBtnText: "قبلی",
                    },
                },
                {
                    element: "#session-links-accordion",
                    popover: {
                        popoverClass: "intro intro-step-4",
                        title: `
                            <div class="intro-header">
                                <p>دریافت منابع آموزشی هر جلسه</p>
                                <button type="button" class="driver-popover-close-btn" aria-label="Close"">×</button>
                            </div>
                        `,
                        description: `
                            <div class="intro-body">
                            <p>در صورت تمایل صوت جلسه را به‌جای ویدیو گوش دهید و منابع آموزشی را دانلود کنید.</p>
                            </div>
                        `,
                        showButtons: ["next", "previous"],
                        showProgress: true,
                        nextBtnText: "متوجه شدم",
                        prevBtnText: "قبلی",
                    },
                },
                {
                    element: "#onboarding-menu",
                    onHighlighted: (_, __, { driver }) => {
                        setTimeout(() => {
                            driver.destroy();
                            onFinsiehd();
                        }, 4000);
                    },
                    disableActiveInteraction: true,
                    popover: {
                        popoverClass: "intro intro-step-5",
                        title: ``,
                        description: `
                            <div class="intro-body">
                            <p>مراحل استفاده از سامانه را در ۴ مرحله ساده توضیح داده‌ایم. هر زمان سوال داشتید، می‌توانید آن‌ها را مشاهده کنید.</p>
                            </div>
                        `,
                        showButtons: [],
                        showProgress: false,
                        side: "bottom",
                        align: "start",
                    },
                },
            ],
        });

        if (display && profile) {
            driverObj.drive();
        }
    }, [display, profile]);

    return <></>;
}
